export default async function init() {
  const elements = document.querySelectorAll('.js-notify-mount[data-initial-state]');

  if (!elements.length) return;

  const [{ default: React }, { createRoot }, { default: NotifySignup }] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import(/* webpackChunkName: "notify-signup" */ './NotifySignup.jsx')
  ]);

  elements.forEach((element) => {
    let state;
    try {
      state = JSON.parse(element.dataset.initialState);
    } catch (err) {
      return;
    }
    if (!state) return;

    // Avoid double-mounting if init runs again (e.g. on reload event).
    if (element.dataset.mounted === 'true') return;
    element.dataset.mounted = 'true';

    createRoot(element).render(<NotifySignup {...state} />);
  });
}
